import React from "react";
import { observer } from 'mobx-react-lite';
import type { UserLanguagesStore, ILangItem } from '../../../data/user/UserLanguagesStore';
import { LanguageSelect } from './LanguageSelect';

/**
 * UserLanguages
 */
export const UserLanguages: React.FC<{
    readonly store: UserLanguagesStore<any, any>;
}> = observer(props => {

    const onItemSelect = (item: ILangItem) => {
        props.store.toggleLanguage(item.value);
    }

    const onRemove = (item: ILangItem) => {
        props.store.toggleLanguage(item.value);
    }

    const onClear = () => props.store.clear();

    // --

    return (
        <LanguageSelect
            languages={props.store.items}
            assignedLangCodes={props.store.assigned}
            selected={props.store.selectedLanguages}
            onSelect={onItemSelect}
            onRemove={onRemove}
            onClear={onClear}
        />
    )
})